import "./BrowserSourceContent.css";
import { useState } from "react";
import BlueButton from "../../../../common/BlueButton/BlueButton";
import Container from "../../../../common/Container";
import notificationService from "../../../../../services/NotificationService";
import { useTranslation } from "react-i18next";

const BrowserSourceLogic = ({ fetchedBrowserSource }) => {
    const { t } = useTranslation("dashboard");

    const [urlIdClass, setUrlIdClass] = useState(
        "urlIDTextDisplayBlurHomeContent",
    );

    const copyToClipboard = async () => {
        await navigator.clipboard.writeText(fetchedBrowserSource);
        notificationService.setMessage(t("browserSourceCopyClipBoard"));
        notificationService.setTitle(t("browserSourceMessageTitle"));
    };

    const changeUrlDisplay = () => {
        if (urlIdClass === "urlIDTextDisplayBlurHomeContent")
            setUrlIdClass("urlIDTextDisplayHomeContent");
        else setUrlIdClass("urlIDTextDisplayBlurHomeContent");
    };

    let content1 = (
        <div className="urlID">
            <p className="browserSourceDescriptionHome">
                {t("browserSourceDescriptionHome")}
            </p>
            <div className="browserSourceLinkAndButtonHome">
                <BlueButton
                    text={
                        urlIdClass === "urlIDTextDisplayBlurHomeContent"
                            ? t("browserSourceShow")
                            : t("browserSourceHide")
                    }
                    onClick={changeUrlDisplay}
                    isDark={true}
                    isGray={false}
                />
                <p className={urlIdClass}>{fetchedBrowserSource}</p>
            </div>
            <div className="CopyButtonBrowserSourceHome">
                <BlueButton
                    isLarge={true}
                    text={t("browserSourceCopyButton")}
                    onClick={copyToClipboard}
                    isGray={false}
                />
            </div>
            <div className="warningContainerUrlId">
                <img
                    className="warningSignImage"
                    src="/warningSign.svg"
                    alt="warning"
                />
                <span className="warningSignText">
                    {" "}
                    {t("browserSourceWarningText")}{" "}
                </span>
            </div>
        </div>
    );

    return (
        <div>
            <Container
                title={"Your OBS Browser Source URL"}
                content={content1}
            />
        </div>
    );
};

export default BrowserSourceLogic;
